import { BASE_URL } from "../../util/Constants";
import HTTP from "../../util/Http";
import { getUserLoggedLS } from "../../util/LocalStorageUtils";

export async function fetchFranjasHorarias(setFranjasHorarias) {
    try {
        const url = BASE_URL + "franjas-horarias";
        await HTTP.get(url).then((response) => setFranjasHorarias(response.data));
    } catch (error) {
        console.error("Error fetching franjas horarias:", error);
        setFranjasHorarias([]);
    }
}

export async function fetchCeldasHorariasProfesor(profesorId, alTerminarCarga) {
    try {
        if (!profesorId) {
            let userLogged = getUserLoggedLS();
            profesorId = userLogged.id;
        }
        const url = BASE_URL + "celdas-horarias/" + profesorId;
        await HTTP.get(url).then((response) => alTerminarCarga(response.data));
    } catch (error) {
        console.error("Error fetching celdas horarias profesor:", error);
        throw error;
    }
}

export async function fetchAusenciasProfesor(profesorId, startDate, endDate, alTerminarCarga) {
    try {
        if (!profesorId) {
            let userLogged = getUserLoggedLS();
            profesorId = userLogged.id;
        }
        const url = BASE_URL + "ausencias-profesor?profesorId=" + profesorId + "&fechaInicio=" + startDate + "&fechaFin=" + endDate;
        await HTTP.get(url).then((response) => alTerminarCarga(response.data));
    } catch (error) {
        console.error("Error fetching ausencias profesor:", error);
        throw error;
    }
}

export async function fetchGuardiasProfesor(profesorId, startDate, endDate, alTerminarCarga) {
    try {
        if (!profesorId) {
            let userLogged = getUserLoggedLS();
            profesorId = userLogged.id;
        }
        const url = BASE_URL + "guardias-profesor?profesorId=" + profesorId + "&fechaInicio=" + startDate + "&fechaFin=" + endDate;
        await HTTP.get(url).then((response) => alTerminarCarga(response.data));
    } catch (error) {
        console.error("Error fetching ausencias profesor:", error);
        throw error;
    }
}

export async function postRegistrarAusencia(profesorId, fecha, franjaId ,observaciones) {
    try {
        if (!profesorId) {
            let userLogged = getUserLoggedLS();
            profesorId = userLogged.id;
        }
        const url = BASE_URL + "registrar-ausencia";
        const data = {
            profesorId: profesorId,
            fecha: fecha,
            franjaId: franjaId,
            observaciones: observaciones            
        };
        const response = await HTTP.post(url, data).then((response) => response);
        if (response.status !== 200) {
            let errorMessage = `Error al registrar la ausencia (Código: ${response.status})`;
            try {
                const errorBody = await response.text();
                if (errorBody) {
                    errorMessage += `: ${errorBody}`;
                }
            } catch (e) {
                console.error("Error al leer el cuerpo de la respuesta de error:", e);
            }
            throw new Error(errorMessage);
        }

        const responseData = await response.data; // O response.json() si el backend devuelve JSON para el éxito
        return responseData; // "Ausencia registrada correctamente"
    } catch (error) {
        console.error("Error posting registrar ausencia:", error);
        throw error;
    }
}

export async function fetchCeldasHorariasPorFecha(profesorId, fecha) {
    try {
        if (!profesorId) {
            let userLogged = getUserLoggedLS();
            profesorId = userLogged.id;
        }
        const url = BASE_URL + "celdas-fecha?profesorId=" + profesorId + "&fecha=" + fecha;
        const response = await HTTP.get(url).then((response) => response);
        if (response.status !== 200) {
            let errorMessage = `Error al registrar la ausencia (Código: ${response.status})`;
            try {
                const errorBody = await response.text();
                if (errorBody) {
                    errorMessage += `: ${errorBody}`;
                }
            } catch (e) {
                console.error("Error al leer el cuerpo de la respuesta de error:", e);
            }
            throw new Error(errorMessage);
        }

        const responseData = await response.data; // O response.json() si el backend devuelve JSON para el éxito
        return responseData;
    } catch (error) {
        console.error("Error fetching celdas horarias profesor:", error);
        throw error;
    }
}

export async function deleteAusencia(ausenciaId) {
    try {
        const url = BASE_URL + "eliminar-ausencia?ausenciaId=" + ausenciaId;
        const response = await HTTP.delete(url).then((response) => response);
        return response.data;
    } catch (error) {
        console.error("Error deleting ausencia:", error);
        throw error;
    }
}

export async function updateObservacionesAusencia(ausenciaId, observaciones) {
    try {
        const url = BASE_URL + "actualizar-observacion-ausencia";
        const data = {
            ausenciaId: ausenciaId,
            observaciones: observaciones
        };
        const response = await HTTP.post(url, data);
        return response.data;
    } catch (error) {
        console.error("Error actualizando observaciones de la ausencia:", error);
        throw error;
    }
}

// función para registrar ausencia de dia completo
export async function postRegistrarAusenciaDiaCompleto(profesorId, fecha, observaciones) {
    try {
        if (!profesorId) {
            let userLogged = getUserLoggedLS();
            profesorId = userLogged.id;
        }
        const url = BASE_URL + "registrar-ausencia-dia-completo";
        const data = {
            profesorId: profesorId,
            fecha: fecha,
            observaciones: observaciones
        };
        const response = await HTTP.post(url, data).then((response) => response);
        return response.data;
    } catch (error) {
        console.error("Error posting registrar ausencia dia completo:", error);
        throw error;
    }
}

export async function firmarAusencia(ausenciaId) {
    try {
        const url = BASE_URL + "firmar-ausencia?ausenciaId=" + ausenciaId;
        const response = await HTTP.post(url).then((response) => response);
        return response.data;
    } catch (error) {
        console.error("Error firmando ausencia:", error);
        throw error;
    }
}

export async function incrementarContadorCeldaHoraria(celdaHorariaId) {
    try {
        const url = BASE_URL + "incrementar-contador-celda-horaria?celdaHorariaId=" + celdaHorariaId;
        const response = await HTTP.post(url).then((response) => response);
        return response.data;
    } catch (error) {
        console.error("Error incrementando contador celda horaria:", error);
        throw error;
    }
}

export async function fetchDetalleGuardia(franjaId, fecha) {
    try {
        const url = BASE_URL + "detalle-guardia?franjaId=" + franjaId + "&fecha=" + fecha;
        const response = await HTTP.get(url).then((response) => response);
        return response.data;
    } catch (error) {
        console.error("Error fetching detalle de guardia:", error);
        throw error;
    }
}

export async function fetchParametro(nombre, asBoolean = false) {
    const url = BASE_URL + `parametro?nombre=${encodeURIComponent(nombre)}&asBoolean=${asBoolean}`;
    return HTTP.get(url).then((response) => response.data);
}

// Ocupación de aulas (filtros opcionales: diaSemanaId, franjaId, fecha, soloLibres)
export async function fetchOcupacionAulas(params = {}) {
    const query = new URLSearchParams();
    if (params.diaSemanaId) query.append("diaSemanaId", params.diaSemanaId);
    if (params.franjaId) query.append("franjaId", params.franjaId);
    if (params.aulaId) query.append("aulaId", params.aulaId);
    if (params.soloLibres) query.append("soloLibres", "true");
    const url = BASE_URL + "aulas-ocupacion" + (query.toString() ? `?${query.toString()}` : "");
    return HTTP.get(url).then((response) => response.data);
}

export async function fetchAulasActivas() {
    const url = BASE_URL + "aulas-activas";
    return HTTP.get(url).then((response) => response.data);
}
